import { panoAutoRotateStarted, panoAutoRotateStopped } from 'aria-viewer/players/panoplayer/actions/panoramaActions'

// TODO : export non-actions constants these to constants file

export const FRONT = 'FRONT'
export const FRONT_INDEX = 1
export const LEFT = 'LEFT'
export const LEFT_INDEX = 2
export const RIGHT = 'RIGHT'
export const RIGHT_INDEX = 3
export const FRONT_SINGLE = 'FRONT_SINGLE'

export const SET_WALKING_DIRECTION = 'SET_WALKING_DIRECTION'
export const FORWARD = 'FORWARD'
export const BACKWARD = 'BACKWARD'

export const SET_ENTRY_POINT = 'SET_ENTRY_POINT'
export const ENTRY_POINT_BEFORE = 'BEFORE'
export const ENTRY_POINT_AFTER = 'AFTER'

export const F = 'F'
export const F_B = 'F_B'
export const F_L = 'F_L'
export const F_R = 'F_R'
export const F_BL = 'F_BL'
export const F_BR = 'F_BR'
export const B = 'B'
export const B_F = 'B_F'
export const B_L = 'B_L'
export const B_R = 'B_R'
export const B_BL = 'B_BL'
export const B_BR = 'B_BR'
export const L = 'L'
export const R = 'R'

export const faceForward = () => {
    return {
        type: FRONT,
    }
}
export const turnRight = () => {
    return {
        type: RIGHT,
    }
}
export const turnLeft = () => {
    return {
        type: LEFT,
    }
}

export const setEntryPoint = entryPoint => {
    return {
        type: SET_ENTRY_POINT,
        entryPoint,
    }
}

// TODO: why is this action calling dispatch?
export const setWalkingDirection = walkingDirection => {
    return dispatch => {
        const panoAutorotateAction = walkingDirection ? panoAutoRotateStarted() : panoAutoRotateStopped()

        dispatch([
            {
                type: SET_WALKING_DIRECTION,
                walkingDirection,
            },
            panoAutorotateAction,
            setEntryPoint(null),
        ])
    }
}
